import InstitutionFormController from '../controllers/InstitutionFormController.js';
import InstitutionNonFormSignInTask from './InstitutionNonFormSignInTask.js';
import Institution from '../models/Institution.js';

class InstitutionSignInTask {
    static run({env}) {
        var promise = env.getUrlParams().hasInstitution()
            ? InstitutionFormController.promise({env})
            : InstitutionNonFormSignInTask.run({env});

        return promise.then(data => env.setInstitution(Institution.deserialize(data)));
    }
}

export default InstitutionSignInTask;